import { Store } from '@ngrx/store';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
import { FolderOperationsService } from 'FoldersApp/services/folder-operations.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
import { PromptModalComponent } from 'NewAngular/features/components/modals/prompt-modal/prompt-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folder-operations.service";
import * as i2 from "@ngrx/store";
import * as i3 from "FoldersApp/services/folderable-collection-service-base.service";
import * as i4 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../ycharts/static/ts/features/components/modals/prompt-modal/prompt-modal.component";
import * as i8 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["promptModalComponent"];
const _c1 = a0 => ({ "visible-md-flex": a0 });
export class FolderCreateComponent {
    constructor(folderOperationsService, store, folderableCollectionService, toastMessagesService) {
        this.folderOperationsService = folderOperationsService;
        this.store = store;
        this.folderableCollectionService = folderableCollectionService;
        this.toastMessagesService = toastMessagesService;
    }
    openModal() {
        this.modal.openModal();
    }
    createFolder(folderName) {
        const targetFolderId = this.folderableCollectionService.viewRootFolder?.id;
        const postParams = { folderName };
        if (targetFolderId) {
            postParams.targetFolderId = targetFolderId;
        }
        this.folderOperationsService.createFolder(postParams).subscribe({
            next: () => {
                this.folderableCollectionService.refreshData();
                this.toastMessagesService.addMessage(`Created folder "${folderName}"`);
                this.modal.closeModal();
            },
            error: (response) => {
                this.toastMessagesService.addMessage(response.error.error_message, ToastMessageType.ERROR);
            },
        });
    }
}
FolderCreateComponent.ɵfac = function FolderCreateComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderCreateComponent)(i0.ɵɵdirectiveInject(i1.FolderOperationsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.FolderableCollectionServiceBase), i0.ɵɵdirectiveInject(i4.PageToastMessagesService)); };
FolderCreateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderCreateComponent, selectors: [["ycn-folder-create"]], viewQuery: function FolderCreateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
    } }, inputs: { visibleFlex: "visibleFlex" }, standalone: false, decls: 5, vars: 10, consts: [["promptModalComponent", ""], [1, "panel-action", 3, "ngClass"], ["ycnTooltip", "", 1, "btn", "btn-transparent2", 3, "click", "tooltipTitle"], ["ycnIcon", "", "role", "img", 1, "icon-folder-add", 3, "name"], [3, "promptHandler", "promptButtonText", "promptHeader", "promptPlaceholder", "modalTestId", "maxInputLength"]], template: function FolderCreateComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
        i0.ɵɵlistener("click", function FolderCreateComponent_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(2, "svg", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(3, "ycn-prompt-modal", 4, 0);
        i0.ɵɵlistener("promptHandler", function FolderCreateComponent_Template_ycn_prompt_modal_promptHandler_3_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.createFolder($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1, ctx.visibleFlex));
        i0.ɵɵadvance();
        i0.ɵɵproperty("tooltipTitle", "Add a Folder");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-folder-add");
        i0.ɵɵadvance();
        i0.ɵɵproperty("promptButtonText", "Create Folder")("promptHeader", "Create Folder")("promptPlaceholder", "Enter a name")("modalTestId", "create-folder-modal")("maxInputLength", 255);
    } }, dependencies: [i5.NgClass, i6.IconDirective, i7.PromptModalComponent, i8.TooltipDirective], encapsulation: 2 });
